import React from "react";

import BellIcon from "../../assets/bellIcon.png";

import useWindowSize from "../hooks/WindowResizer";
import MobileViewHeader from "./MobileViewHeader";

const Header = () => {
  const isMobileView = useWindowSize();
  return (
    <>
      {!isMobileView && (
        <div className="bell">
          <img src={BellIcon} alt="bellIcon" className="belli" />
        </div>
      )}

      {isMobileView && <MobileViewHeader />}
    </>
  );
};

export default Header;
